import { writePackageCartToCache } from "@/Apollo/hooks/package-cart/packageCartCache";
import { useDisplayCurrencyMutation } from "@/Apollo/hooks/useDisplayCurrencyMutation";
import mutationGQL from "@/Apollo/mutation/package-cart/addBoostToPackageCart.graphql";
import {
  AddBoostToPackageCartMutation,
  AddBoostToPackageCartMutationVariables,
} from "@/Apollo/schema";
import { MutationHookOptions } from "@apollo/client";

export const useAddBoostToPackageCart = (
  options?: MutationHookOptions<
    AddBoostToPackageCartMutation,
    AddBoostToPackageCartMutationVariables
  >
) => {
  return useDisplayCurrencyMutation(mutationGQL, {
    ...options,
    update(cache, result, updateOptions) {
      writePackageCartToCache(
        cache,
        result.data?.addBoostToPackageCart,
        updateOptions.variables?.displayCurrency ?? undefined
      );
      options?.update?.(cache, result, updateOptions);
    },
  });
};
